import { EChatModalActionType, IOpenChatModalPayload } from './types';
import { TThunkAction } from '../../types/redux';
import { backFromModalHistoryEntry, hasModalHistoryEntry, openModalHistoryEntry } from '../../utils/modalHistory';
import { actionGenerator } from '../../utils/redux/actionGenerator';

const HISTORY_ENTRY_NAME = 'ChatModal';

const openChatModalAction = actionGenerator<EChatModalActionType.Open, IOpenChatModalPayload>(
  EChatModalActionType.Open,
);
const openChatModalAfterAuthAction = actionGenerator<EChatModalActionType.OpenAfterAuth, IOpenChatModalPayload>(
  EChatModalActionType.OpenAfterAuth,
);
const closeChatModalAction = actionGenerator<EChatModalActionType.Close>(EChatModalActionType.Close);

export const openChatModal =
  (payload: IOpenChatModalPayload): TThunkAction =>
  dispatch => {
    dispatch(openChatModalAction(payload));
    openModalHistoryEntry(HISTORY_ENTRY_NAME, () => {
      dispatch(closeChatModalAction());
    });
  };

export const openChatModalAfterAuth =
  (payload: IOpenChatModalPayload): TThunkAction =>
  dispatch => {
    dispatch(openChatModalAfterAuthAction(payload));
    openModalHistoryEntry(HISTORY_ENTRY_NAME, () => {
      dispatch(closeChatModalAction());
    });
  };

export const closeChatModal = (): TThunkAction => dispatch => {
  // Чат с записью в history: закрываем шагом назад, закроет «назад» записи
  if (hasModalHistoryEntry(HISTORY_ENTRY_NAME)) {
    void backFromModalHistoryEntry(HISTORY_ENTRY_NAME);

    return;
  }

  dispatch(closeChatModalAction());
};
